// import { useQuery } from '@tanstack/react-query';
// import { Empty, Flex, Skeleton, Timeline, Typography } from 'antd';
// import { useContext, useEffect, useRef, useState } from 'react';
// import { useParams } from 'react-router-dom';
// import { getTopicDetails } from 'src/apis/helpdesk/topic.api';
// import Dot from 'src/assets/icons/dot.png';
// import Icon from 'src/components/v2/Icon';
// import { ITopicDetail } from 'src/types/helpdesk/topic.type';
// import { TopicContext } from 'src/contexts/topic.context';
// import { formatDate, formatTime, scrollToReply } from 'src/utils/utils';
// const { Text } = Typography;
import './Activity.scss';

function Activity() {
  // const { id } = useParams();
  // const [topicDetails, setTopicDetails] = useState<ITopicDetail[]>([]);
  // const prevIdRef = useRef<string>();
  // const [currentId, setCurrentId] = useState<string | undefined>(id);
  // const { setPage } = useContext(TopicContext);

  // useEffect(() => {
  //   setCurrentId((prev) => {
  //     prevIdRef.current = prev;

  //     return id;
  //   });
  // }, [id]);

  // const topicDetailsQuery = useQuery({
  //   queryKey: ['activityTopicDetails', String(currentId)],
  //   queryFn: () => getTopicDetails(String(currentId), true),
  //   staleTime: 60 * 1000
  // });

  // useEffect(() => {
  //   if (topicDetailsQuery.data?.data) {
  //     if (currentId !== prevIdRef.current) {
  //       setTopicDetails(topicDetailsQuery.data?.data);
  //     } else {
  //       setTopicDetails((prev) => [...prev, ...topicDetailsQuery.data?.data]);
  //     }
  //   }
  // }, [topicDetailsQuery.data, currentId]);

  return (
    <div className='topic-detail'>
      {/* {topicDetails.length > 0 ? (
        <Timeline
          className='topic-detail-time-line'
          mode='left'
          items={topicDetails.map((topicDetail) => ({
            key: topicDetail.id,
            className: 'topic-detail-time-item',
            children: (
              <Skeleton
                active
                title={false}
                paragraph={{ rows: 2, width: '100%' }}
                loading={topicDetailsQuery.isFetching}
              >
                <div
                  className='topic-detail-content'
                  onClick={() => {
                    const index = currentTopicMessagesGroup?.findIndex((x) => x?.id === topicDetail.id);
                    const pageOfIndex = Math.ceil((index || 0) / 10);

                    setPage((prev) => {
                      if (pageOfIndex > prev) {
                        return pageOfIndex;
                      }
                      return prev;
                    });

                    scrollToReply(String(topicDetail.id), 'center');
                  }}
                >
                  <div className='topic-detail-content-wrapper'>
                    <div className='topic-detail-content-time'>
                      <Flex vertical justify='center' align='center'>
                        <Text strong>{formatTime(topicDetail.createdDate)}</Text>
                        <Text>{formatDate(topicDetail.createdDate)}</Text>
                      </Flex>
                    </div>
                    <div className='topic-detail-content-text'>{topicDetail.content}</div>
                  </div>
                </div>
              </Skeleton>
            ),
            dot: <Icon url={Dot} size={15} />
          }))}
        />
      ) : (
        <Empty
          image='https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg'
          imageStyle={{ height: 60 }}
          description={'Không có hoạt động'}
        />
      )} */}
    </div>
  );
}

export default Activity;
